import AnimalBirds from "../../components/ClassThree/Science/AnimalBirds";
import AnimalFoodHabits from "../../components/ClassThree/Science/AnimalFoodHabits";
import AnimalInsect from "../../components/ClassThree/Science/AnimalInsect";
import FoodsFromPlant from "../../components/ClassThree/Science/FoodsFromPlant";
import FormsOfMatter from "../../components/ClassThree/Science/FormsOfMatter";
import HealthHygine from "../../components/ClassThree/Science/HealthHygine";
import HumanBody from "../../components/ClassThree/Science/HumanBody";
import LivingNonLiving from "../../components/ClassThree/Science/LivingNonLiving";
import NaturalResource from "../../components/ClassThree/Science/NaturalResource";
import SoilProperties from "../../components/ClassThree/Science/SoilProperties";
import SurroundingPlant from "../../components/ClassThree/Science/SurroundingPlant";
import WaterProperties from "../../components/ClassThree/Science/WaterProperties";
import WaterResource from "../../components/ClassThree/Science/WaterResource";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/class-three/science/living-non-living-things", title: "Living and Non-living Things", component: LivingNonLiving},
    { url: "/class-three/science/human-body", title: "Human Body", component: HumanBody},
    { url: "/class-three/science/animals-birds", title: "Animals: Birds", component: AnimalBirds},
    { url: "/class-three/science/animals-common-insects", title: "Animals: Common Insects", component: AnimalInsect},
    { url: "/class-three/science/animals-feeding-habits", title: "Animals: Food & Feeding Habbits", component: AnimalFoodHabits},
    { url: "/class-three/science/plants-in-the-surroundings", title: "Plants in the Surroundings", component: SurroundingPlant},
    { url: "/class-three/science/food-we-get-from-plants", title: "Food We Get from Plants", component: FoodsFromPlant},
    { url: "/class-three/science/forms-matter-solids-liquids-gases", title: "Forms of Matter: Solids, Liquids & Gases", component: FormsOfMatter},
    { url: "/class-three/science/soil", title: "Soil", component: SoilProperties},
    { url: "/class-three/science/water-resource", title: "Water as a Resource", component: WaterResource},
    { url: "/class-three/science/sun-natural-resource", title: "Sun as a Natural Resource", component: NaturalResource},
    { url: "/class-three/science/cleanliness-health-hygiene", title: "Cleanliness, Health and Hygiene", component: HealthHygine},
];


export default topics;